import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Switch as AntdSwitch, Flex } from 'antd';
import { BgWrapperEditorInput } from '../../editor.style';
const Switch = ({ value, onChange, label = '', ...restProps }) => {
    const handleChange = (value) => {
        onChange?.(value);
    };
    return (_jsx(BgWrapperEditorInput, { children: _jsxs(Flex, { align: "center", gap: "10px", children: [_jsx(AntdSwitch, { checked: value, onChange: handleChange, ...restProps, size: "small" }), " ", label] }) }));
};
export default React.memo(Switch);
